import styled from 'styled-components';

import EditLessonSvg from '../../assets/icons/EditLessonSvg';
import PlaySvg from '../../assets/icons/PlaySvg';
import ResumeSvg from '../../assets/icons/ResumeSvg';
import theme from '../../assets/theme';
import { useBreakPoint } from '../../hooks/useBreakPoint';
import { useMetrics } from '../../hooks/useMetrics';
import BaseModal from '../_molecules/BaseModal';
import { Button } from './Button';

const ResumeLessonModal = ({
  onStartNewLesson,
  onResumeLesson,
  onEndLesson,
  isOnGoingGameModalVisible,
  currentPage,
  onCancel,
}: {
  onStartNewLesson: () => void;
  onEndLesson: () => void;
  onResumeLesson: () => void;
  isOnGoingGameModalVisible: boolean;
  currentPage: 'designer' | 'lessonPage';
  onCancel: () => void;
}) => {
  const metrics = useMetrics();
  const isLargetThan650 = useBreakPoint(650);

  return (
    <BaseModal width="800px" visible={isOnGoingGameModalVisible} onCancel={onCancel}>
      <h1 style={{ fontSize: isLargetThan650 ? 36 : 30 }}>You have an ongoing lesson</h1>
      <p
        style={{
          width: '100%',
          maxWidth: 650,
          margin: '0 auto 20px auto',
          textAlign: 'center',
          fontSize: 20,
        }}
      >
        A lesson can be run multiple times and generates a unique report.{' '}
        {currentPage === 'designer' && 'Editing this lesson will end the ongoing lesson.'}
      </p>

      <div
        style={{
          display: 'flex',
          flexDirection: isLargetThan650 ? 'row' : 'column-reverse',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '100%',
          gap: 20,
        }}
      >
        <Button
          width={isLargetThan650 ? '50%' : '100%'}
          type="ghost"
          styles={{ fontSize: isLargetThan650 ? 18 : 16 }}
          height="42px"
          icon={<ResumeSvg />}
          onClick={() => {
            metrics.logEvent('ResumeLessonModal.Roadblock.ResumeLesson', {
              page: currentPage,
            });
            onResumeLesson();
          }}
        >
          Resume
        </Button>
        {currentPage === 'designer' && (
          <Button
            width={isLargetThan650 ? '50%' : '100%'}
            type="primary"
            styles={{ fontSize: isLargetThan650 ? 18 : 16 }}
            icon={<EditLessonSvg />}
            onClick={() => {
              metrics.logEvent('ResumeLessonModalator.Roadblock.EndLesson', {
                page: currentPage,
              });
              onEndLesson();
            }}
          >
            Edit
          </Button>
        )}
        {currentPage === 'lessonPage' && (
          <Button
            width={isLargetThan650 ? '50%' : '100%'}
            type="primary"
            styles={{ fontSize: isLargetThan650 ? 18 : 16 }}
            icon={<PlaySvg />}
            onClick={() => {
              metrics.logEvent('ResumeLessonModal.Roadblock.StartNew', {
                page: currentPage,
              });
              onStartNewLesson();
            }}
          >
            Start New
          </Button>
        )}
      </div>
      {currentPage === 'designer' && (
        <EndLesson
          onClick={() => {
            metrics.logEvent('ResumeLessonModal.Roadblock.StartNew', {
              page: currentPage,
            });
            onStartNewLesson();
          }}
          type="linkStyle"
        >
          Start new
        </EndLesson>
      )}
    </BaseModal>
  );
};

const EndLesson = styled(Button)`
  margin-top: 20px;
  text-align: center;
  color: ${theme.colors.black};
  cursor: pointer;
  width: 100%;
`;

export default ResumeLessonModal;
